import { createSelector } from '@reduxjs/toolkit';
import { ObjectOfAny } from '../reducers/types';
import { RootState } from '../store/store';

const applicationSettingsProjections = {} as ObjectOfAny;

applicationSettingsProjections.maxAttachmentsSizeInBytes = createSelector(
    (state: RootState) => state.applicationSettings.apiApplicationSettings,
    apiApplicationSettings => {
        return apiApplicationSettings
            ? apiApplicationSettings.maxAttachmentSizeInMB * 1000 * 1000
            : null;
    },
);

applicationSettingsProjections.getCountry = createSelector(
    (state: RootState) => state.applicationSettings.apiApplicationSettings,
    apiApplicationSettings => {
        if (apiApplicationSettings === null) {
            return null;
        }
        return apiApplicationSettings.currentCountryCode;
    },
);

applicationSettingsProjections.getAragSocialMediaImages = createSelector(
    (state: RootState) => state.applicationSettings.apiApplicationSettings,
    apiApplicationSettings => {
        if (apiApplicationSettings === null) {
            return [];
        }
        return apiApplicationSettings.aragSocialMediaImages;
    },
);

export default applicationSettingsProjections;
